import { Arrow, type ArrowProps } from "./content/arrow/arrow";
import { Content, type ContentProps } from "./content/content";
import { Provider, type ProviderProps } from "./provider";
import { Tooltip as TooltipRoot, TooltipProps } from "./tooltip";
import { Trigger, type TriggerProps } from "./trigger";

const Tooltip = Object.assign(TooltipRoot, {
    Provider: Provider,
    Trigger: Trigger,
    Content: Object.assign(Content, {
        Arrow: Arrow,
    }),
});

export {
    Tooltip,
    Provider as TooltipProvider,
    Content as TooltipContent,
    Arrow as TooltipContentArrow,
    Trigger as TooltipTrigger,
};
export type {
    TooltipProps,
    ProviderProps as TooltipProviderProps,
    ContentProps as TooltipContentProps,
    ArrowProps as TooltipContentArrowProps,
    TriggerProps as TooltipTriggerProps,
};
